import MuiDialogTitle from '@mui/material/DialogTitle';

import { styled } from 'helpers';

import { Props } from './types';

export const DialogTitle = styled(MuiDialogTitle)<Props>`
  font-size: ${({ theme }) => theme.typography.pxToRem(24)};
  padding: 0 32px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    font-size: ${({ theme }) => theme.typography.pxToRem(18)};
    padding-left: ${({ theme }) => theme.spacing(3)};
    padding-right: ${({ theme }) => theme.spacing(3)};
  }
`;

export default DialogTitle;
